import { type MinimumAddress, type SavedCustomerAddress } from '../../locations.types';
import { checkIfSameAddress } from '../checkIfSameAddress';

export const findExistingDeliveryAddress = (
  customerDeliveryAddresses: Readonly<SavedCustomerAddress[]> | SavedCustomerAddress[],
  address: MinimumAddress,
) => {
  return customerDeliveryAddresses.find((customerAddress) =>
    checkIfSameAddress(customerAddress, address),
  );
};
